import { createContext, useContext, useState, useEffect, useRef } from "react";
import { userServices } from "../APIServices/UserData/userServices";
import { plateformSettingServices } from "../APIServices/PasswordManagement/plateformSettingServices";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [currentUserData, setCurrentUserData] = useState(null);
  const [plateformSettings, setPlateformSettings] = useState(null);
  const [organizationList, setOrganizationList] = useState([]);
  const [isDark, setIsDark] = useState(false);
  const [auth, setAuth] = useState("");

  const vaultKeyRef = useRef(null);
  const setVaultKey = (key) => (vaultKeyRef.current = key);
  const getVaultKey = () => vaultKeyRef.current;
  const clearVaultKey = () => (vaultKeyRef.current = null);

  const getCurrectLoginUser = async () => {
    const data = await userServices.getCurrectLoginUser(auth);
    setCurrentUserData(data?.data || null);
  };

  const getOrganizations = async () => {
    let data = await userServices.getOrganizations(auth)
    setOrganizationList(data?.data || [])
  }

  const getSinglePlateformSettings = async () => {
    const data = await plateformSettingServices.getSinglePlateformSettings(auth);
    setPlateformSettings(data?.data || null);

    const status = data?.data?.settings?.themeSettings === "dark";
    setIsDark(status);

    if (typeof document !== "undefined") {
      document.body.classList.toggle("dark-theme", status);
      document.documentElement.setAttribute(
        "data-bs-theme",
        status ? "dark" : "light"
      );
    }
  };

  useEffect(() => {
    if (auth) {
      getSinglePlateformSettings();
      getCurrectLoginUser();
      getOrganizations();
    }
    const status = localStorage.getItem("themeSettings") === "dark";
    setIsDark(status);
    if (typeof document !== "undefined") {
      document.body.classList.toggle("dark-theme", status);
      document.documentElement.setAttribute(
        "data-bs-theme",
        status ? "dark" : "light"
      );
    }
  }, [auth]);

  return (
    <AppContext.Provider
      value={{
        // User
        setAuth,
        auth,
        currentUserData,
        setCurrentUserData,
        getCurrectLoginUser,

        // Platform / Theme
        plateformSettings,
        setPlateformSettings,
        isDark,
        setIsDark,
        getSinglePlateformSettings,

        //Organization
        getOrganizations,
        organizationList,

        // Vault
        setVaultKey,
        getVaultKey,
        clearVaultKey,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
